export const JSON_HEADER = { 'Content-Type': 'application/json' };
export const AUTH_HEADER = (token) => ({ Authorization: `Bearer ${token}` });
import data from './config.json';
export const config = data;
